const rakenteet = [
  {
    index: '6',
    label: 'Ranka',
    category: 'ranka',
    osat: [95, 102]
  },
  {
    index: '7',
    label: 'CLT',
    category: 'clt-lvl',
    osat: [96, 103]
  },
  {
    index: '8',
    label: 'Hirsi',
    category: 'hirsi',
    osat: [98]
  },
  {
    index: '27',
    label: 'Massiivi-CLT',
    category: 'massiivi-clt',
    osat: [96, 103]
  },
  {
    index: '28',
    label: 'LVL',
    category: 'lvl',
    osat: [97, 101]
  }
]

export const rakenneResolv = (id, value = 'label', defaultValue = '') => {
  for (let i = 0; i < rakenteet.length; i++) {
    const kt = rakenteet[i]
    // This is not an error, stupid linter!!!
    // eslint-disable-next-line
    if (kt.index == id) {
      return kt[value]
    }
  }
  return defaultValue
}

export default rakenteet



// WEBPACK FOOTER //
// ./src/data/rakenteet.js